<script>
export const group = 'Full'
export const reuseComponent = true
</script>

<script setup>
import LiveLocationMap from '../default/LiveLocationMap.vue'
import ToFullBottomRight from './transitions/energetic_frequencies/ToFullBottomRight.vue'

defineProps({
  item: Object,
})
</script>

<template>
  <ToFullBottomRight>
    <LiveLocationMap :item="item" />
  </ToFullBottomRight>
</template>
